import { addLanguageToPath, SupportedLanguage } from "../languages";

export const PRACTICE_SLUGS = ["speechoftheday", "custompractice"] as const;

export type PracticeSlug = (typeof PRACTICE_SLUGS)[number];

export const isPracticeSlug = (slug: string): slug is PracticeSlug => {
  return PRACTICE_SLUGS.includes(slug as PracticeSlug);
};

export type PracticeConfig = {
  slug: PracticeSlug;
  labelKey: string;
  titleKey: string;
  descriptionKey: string;
};

export const PRACTICE_ITEMS: PracticeConfig[] = [
  {
    slug: "speechoftheday",
    labelKey: "practice.speechoftheday.label",
    titleKey: "practice.speechoftheday.title",
    descriptionKey: "practice.speechoftheday.description",
  },
  {
    slug: "custompractice",
    labelKey: "practice.custompractice.label",
    titleKey: "practice.custompractice.title",
    descriptionKey: "practice.custompractice.description",
  },
];

export const getPracticeBySlug = (slug: string): PracticeConfig | undefined => {
  return PRACTICE_ITEMS.find((item) => item.slug === slug);
};

export const getPracticePath = (
  slug: PracticeSlug,
  language: SupportedLanguage
): string => {
  return addLanguageToPath(`/practice/${slug}`, language);
};
